<div class="flex justify-end items-end flex-wrap gap-1 mb-1">
  <!-- <nz-page-header nzTitle="Role Management"> Role Management</nz-page-header> -->
  <button nz-button nzType="primary" type="button" (click)="openFormModal()"><i nz-icon nzType="plus" class="mr-2"></i>
    Add
    Role </button>
</div>

<nz-table #filterTable nzShowSizeChanger [nzData]="displayRoles" nzTableLayout="fixed" [nzLoading]="isLoading"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'"
  [nzShowTotal]="totalTemplate">
  <thead>
    <tr>
      @for (column of listOfColumns; track column) {
      <th>
        {{ column.name }}
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of filterTable.data; track data.id) {
    <tr>
      <td>{{ data.id }}</td>
      <td>
        <span class="inline-flex items-center gap-2">
          <span>{{ data.name }}</span>
          @if (isDefaultRole(data)) {
          <nz-tag nzColor="blue">Default</nz-tag>
          }
        </span>
      </td>
      <td>{{ data.privilege }}</td>
      <td nzEllipsis="...">
        <span
          [nz-tooltip]="isDefaultRole(data) ? 'Default roles cannot be edited' : 'Edit'"
          [nzTooltipColor]="'#fff'"
          nz-icon
          nzType="edit"
          nzTheme="outline"
          (click)="onEditRoleClick(data, $event)"
          class="text-base text-primary"
          [class.cursor-pointer]="!isDefaultRole(data)"
          [class.cursor-not-allowed]="isDefaultRole(data)"
          [class.opacity-50]="isDefaultRole(data)"
        ></span>

        @if (!isDefaultRole(data)) {
        <span
          nz-tooltip="Delete"
          [nzTooltipColor]="'#fff'"
          nz-icon
          nzType="delete"
          nzTheme="outline"
          class="text-base text-danger ml-5 cursor-pointer"
          nz-popconfirm
          nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?"
          (nzOnConfirm)="onDeleteConfirm(data)"
        ></span>
        } @else {
        <span
          nz-tooltip="Default roles cannot be deleted"
          [nzTooltipColor]="'#fff'"
          nz-icon
          nzType="delete"
          nzTheme="outline"
          class="text-base text-danger ml-5 cursor-not-allowed opacity-50"
          (click)="onDeleteRoleClick(data, $event)"
        ></span>
        }

        @if (blockedDefaultRoleMessageForId === data.id) {
        <div class="mt-1 text-xs text-amber-600">
          Default roles cannot be modified.
        </div>
        }
      </td>
    </tr>
    }
  </tbody>
</nz-table>
<nz-modal [(nzVisible)]="isFormModalVisible" nzTitle="Add Role" (nzOnCancel)="isFormModalVisible=false"
  [nzFooter]="modalFooter" nzWidth="500px">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="roleForm" (ngSubmit)="submitForm()">
      <!-- Role Name Field -->
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Role Name</nz-form-label>
        <nz-form-control [nzSm]="16" [nzXs]="24" nzErrorTip="Please enter a role name">
          <input nz-input formControlName="roleName" placeholder="Enter role name" />
        </nz-form-control>
      </nz-form-item>

      <!-- Privilege Field -->
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Privilege</nz-form-label>
        <nz-form-control [nzSm]="16" [nzXs]="24" nzErrorTip="Please select a privilege">
          <nz-select formControlName="privilege" nzPlaceHolder="Select privilege" class="w-full" nzShowSearch
            nzShowArrow="false">
            <nz-option *ngFor="let privilege of privilegeOptions" [nzValue]="privilege.priv"
              [nzLabel]="privilege.roleName + ' (' + privilege.priv + ') '">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <div class="flex justify-end gap-2">
      <button nz-button nzType="default" (click)="isFormModalVisible=false">Cancel</button>
      <button nz-button nzType="primary" [nzLoading]="isLoading" (click)="submitForm()">
        Save
      </button>
    </div>
  </ng-template>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>